<template>
  <el-select v-model="selected" v-bind="$attrs" v-on="$listeners">
    <el-option
      v-for="item in []"
      :key="item.value"
      :label="item.label"
      multiple
      collapse-tags
      :value="item.value">
    </el-option>
    <div slot="empty" class="custom-tree__box">
      <el-input placeholder="输入关键字进行过滤" v-model="filterText" clearable class="custom-tree__search" @input="inputChange">
        <el-button slot="prepend"></el-button>
      </el-input>
      <el-tree
        :data="effectiveData"
        :show-checkbox="false"
        default-expand-all
        :node-key="props.id || 'id'"
        ref="tree"
        :indent="8"
        :expand-on-click-node="false"
        highlight-current
         @node-click="nodeClick"
        :check-strictly="checkStrictly"
        :filter-node-method="filterNode"
        :props="props">
      </el-tree>
    </div>
  </el-select>
</template>

<script>
export default {
  name: 'yblOrganizationTree',
  model: {
    prop: 'checked'
  },
  props: {
    items: {
      type: Array | Object,
      default: () => []
    },
    checked: {
      type: Array | String,
      default: () => []
    },
    props: {
      type: Object,
      default () {
        return { label: 'label', children: 'children', id: 'id', disabled: 'disabled' }
      }
    }
  },
  data () {
    return {
      selected: '',
      checkStrictly: true,
      filterText: '',
      isFilter: false,
      effectiveData: [],
      originTreeData: [],
      currentItem: {}, // 当前选中的节点对象
      defaultCheckedKeys: [] // 默认选中项目
    }
  },
  created () {
    this.initOrganizationTree()
  },
  methods: {
    initOrganizationTree () {
      let originOrganization = this.items
      let parent = originOrganization[originOrganization.length - 1]
      this.effectiveData = this.initTreeData(this.items, parent.ParentId)
    },
    filterNode (value, data) {
      if (!value) return true
      return data[this.props.label].indexOf(value) !== -1
    },
    inputChange (val) {
      // this.isFilter = !!val
      // this.effectiveData = this.isFilter ? [...this.items] : this.initOrganizationTree()
      this.$nextTick(() => {
        this.$refs.tree.filter(val)
      })
    },
    initTreeData (data, parentId, level = 0) {
      if (level > 3) {
        return []
      }
      let dd = data.filter(item => +item.ParentId === +parentId).reduce((sum, item, index) => {
        sum.push({
          ...item,
          level: level, // 标记层级 0/1/2/3/...
          children: this.initTreeData(data, item.OrganizationId, level + 1)
          // hasChildren: item.OrgStatisticInfo && +item.OrgStatisticInfo.ChildOrgNum > 0
        })
        return sum
      }, [])
      return dd
    },
    nodeClick (item, node, vm) {
      // console.log('nodeClick=', item, node, vm)
      this.selected = item.OrganizationName
      this.$emit('select', item)
    },
    getEffectiveData (data) {
      let temp = JSON.stringify(data)
      temp = JSON.parse(temp)
      // console.log('temp=', temp)
      return (temp || []).reduce((array, cur) => {
        if (cur.Status !== -1) {
          cur.Childrens && (cur.Childrens = this.getEffectiveData(cur.Childrens))
          array.push(cur)
        }
        return array
      }, [])
    }
  }
}
</script>

<style lang="less" scoped>
.el-tree{
  max-height: 400px;
  overflow: auto;
}
.custom-tree{
  &__box{
    padding: 5px 3px;
  }
  &__search{
    padding-bottom: 5px;
  }
  &__delete{
    text-decoration: line-through;
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OrganizationTree.vue